@import 'styles/mixins';
@import 'styles/variables';

$tabWidthMax: 240 + 1; // +1px for border-right
$tabWidthMin: 96 + 1;
$newTabButtonLeftPadding: 8;
$newTabButtonWidth: 32 + $newTabButtonLeftPadding;
:export {
  tabWidthMax: $tabWidthMax;
  tabWidthMin: $tabWidthMin;
  newTabButtonWidth: $newTabButtonWidth;
}

.tab {
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 0 8px 0 12px;
  font-size: 12px;
  color: $grey-50;

  &:not(.active)::before {
    content: '';
    height: 32px;
    border-right: 1px solid $grey-10;
    position: absolute;
    right: -1px;
    bottom: 0;
  }

  flex-basis: $tabWidthMax * 1px;
  min-width: $tabWidthMin * 1px;
  position: absolute;
  transition: left 0.15s, width 0.15s;

  border-radius: 8px 8px 0px 0px;

  &.isDragged {
    transition: left 0.05s, width 0.15s;
  }

  cursor: pointer;

  &:not(.active):hover {
    background-color: $grey-5;
  }
}

.active {
  background-color: white;
  color: $grey-90;
  z-index: 1;

  &::before,
  &::after {
    content: '';
    position: absolute;
    box-sizing: content-box;
    pointer-events: none;
    width: 8px;
    height: 8px;
    bottom: -4px;
  }
  &::before {
    left: -8px;
    border-bottom-right-radius: 100%;
    border-bottom: 4px solid white;
    border-right: 4px solid white;
  }
  &::after {
    right: -8px;
    border-bottom: 4px solid white;
    border-left: 4px solid white;
    border-bottom-left-radius: 100%;
  }
}

.titleCloseBtn,
.newTab {
  padding: 0 !important;
  transition: none;
  aspect-ratio: 1;

  &:hover {
    background-color: $grey-10;
  }
}

.titleCloseBtn {
  width: 24px;
  min-height: 24px;
  border-radius: 100%;
}

.tab:not(.active) .titleCloseBtn {
  visibility: hidden;
}

.tab:hover .titleCloseBtn {
  visibility: visible;
}

.titleCloseBtnIcon,
.newTabIcon {
  fill: $grey-50;
  opacity: 80%; // make it a bit lighter
}

.titleLabel {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1;
}

.newTabWrapper {
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: $newTabButtonWidth * 1px;
  padding-left: $newTabButtonLeftPadding * 1px;
}
